export default "__VITE_ASSET__dhQuJc7G__"